export default Object.freeze({
  LAYOUT_SIZE: '900px',
  BLUR_STYLE: {
    background: 'rgba( 0, 0, 0, 0.6)',
    filter: 'blur(4px)',
  },
});
